import { thousandsSeparators } from 'lib/thousandsSeperator'
import React, { FC, ReactElement } from 'react'
export interface Props {
  /** The active municipality */
  activeMunicipality?: any
  /** The selected income form the dropdown */
  selectedIncome: number
  /** Last rank  */
  lastRank: number
}
export const ActiveMunicipality: FC<Props> = ({
  activeMunicipality,
  selectedIncome,
  lastRank
}): ReactElement => {
  return (
    <div className='inner-tooltip active-municipality-container'>
      {activeMunicipality && (
        <>
          <div className='municipality-name'>
            {activeMunicipality.GemeindenameDE}
          </div>
          <div className='percentage'>
            Belastung:
            <span className='number'>{activeMunicipality.Belastung + '%'}</span>
          </div>
          <div className='amount'>
            Fällige Steuer:
            <span className='number'>
              {thousandsSeparators(
                ((activeMunicipality.Belastung / 100) * selectedIncome).toFixed(
                  2
                )
              )}
              {'  CHF'}
            </span>
          </div>
          <div className='rank'>
            Rang: <span> {activeMunicipality.Rank}</span>/{lastRank}
          </div>
        </>
      )}
    </div>
  )
}
